import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  HStack,
  IconButton,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

const getPageNumbers = (currentPage, totalCount, pageSize) => {
  const maxPage = Math.ceil(totalCount / pageSize);

  // Calculate the previous, current, and next page
  if (maxPage <= 1) return [1];
  const pages = [];
 if (currentPage === maxPage && maxPage >2) pages.push(currentPage - 2);
  if (currentPage > 1) pages.push(currentPage - 1); // Previous page

  // Next page
  pages.push(currentPage); // Current page
  if (currentPage === maxPage) return pages;
  if (currentPage < maxPage ) pages.push(currentPage + 1); // Next page
  if (currentPage === 1 && maxPage >2) pages.push(currentPage + 2); // Next page

  return pages;
};

export const PagingControls = (props) => {
  const [pages, setPages] = useState(
    getPageNumbers(props.currentPage, props.totalCount, props.pageSize)
  );

  useEffect(() => {
    setPages(
      getPageNumbers(props.currentPage, props.totalCount, props.pageSize)
    );
  }, [props.currentPage, props.totalCount, props.pageSize]);

  if (props.currentPage < 1) {
    return (
      <Alert status='error'>
        <AlertIcon />
        <AlertTitle>The current page index is invalid</AlertTitle>
        <AlertDescription>
          The current page index cannot be lower than 1. It currently is '
          {props.currentPage}'
        </AlertDescription>
      </Alert>
    );
  }

  const maxPage = Math.ceil(props.totalCount / props.pageSize);

  if (props.currentPage > maxPage && props.totalCount > props.pageSize) {
    return (
      <Alert status='error'>
        <AlertIcon />
        <AlertTitle>The current page index is invalid</AlertTitle>
        <AlertDescription>
          The current page index cannot be greater than the maximum number of
          pages '{maxPage}'. It currently is '{props.currentPage}'
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Stack align='center'>
      {pages.length > 0 && (
        <HStack>
          <IconButton
            disabled={props.currentPage === 1}
            aria-label='previous'
            onClick={() => props.onGoToPage(props.currentPage - 1)}
            icon={<ArrowBackIcon />}
          />
          {pages.map((pageNumber) => (
            <Button
              key={pageNumber}
              onClick={() => props.onGoToPage(pageNumber)}
              colorScheme={
                pageNumber === props.currentPage ? "teal" : undefined
              }
            >
              {pageNumber}
            </Button>
          ))}
          <IconButton
            aria-label='next'
            disabled={props.currentPage === maxPage}
            onClick={() => props.onGoToPage(props.currentPage + 1)}
            icon={<ArrowForwardIcon />}
          />
        </HStack>
      )}
      {props.showPageCount && (
        <Text fontWeight='extrabold' fontSize='md' color='gray.500'>
          {props.totalCount} {props.totalCountDescription}
        </Text>
      )}
    </Stack>
  );
};
